<template>
  <v-main class="pt-0 text-left">
    <v-row class="ml-6 mt-6 mr-6 mb-6">
      <v-col cols="12" mb-4>
        <h2>
          {{ $t('L_welcome_back') }}
        </h2>
      </v-col>
      <v-col cols="12" my-2>
        <p>{{ $t('L_payment_in_case_you_need') }}</p>
      </v-col>
      <v-col cols="12" sm="6" mb-4>
        <div>{{ $t('L_payment_zip_postal_code') }}</div>
        <p class="text-h5 font-weight-bold">
          {{ zipCode }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" mb-4>
        <div>{{ $t('L_payment_policy_number') }}</div>
        <p class="text-h5 font-weight-bold" @click="copyPolicyToClipboard()">
          {{ contractId }}
          <span class="clickable font-size--16 font-weight-bold blue_label">
            <v-icon color="primary" :icon="mdiContentCopy" /> {{ $t('L_copy') }}
          </span>
        </p>
        <div>
          <b>{{ $t('L_enter_in_account_number_field_when_prompted') }}</b>
        </div>
      </v-col>
      <v-col cols="12" mt-2>
        <p>{{ $t('L_payment_if_you_made') }}</p>
        <p>{{ $t('L_payment_you_should_receive') }}</p>
        <p>{{ $t('L_payment_payments_made_before') }}</p>
        <p>{{ $t('L_payment_payments_made_after') }}</p>
      </v-col>
      <v-col cols="12" class="mt-4 maxwidthButton mx-auto">
        <OnexButton
          id="one_tp_kubra_done"
          block
          class="text-white float-right"
          color="primary"
          @click="refreshAndClose"
        >
          {{ $t('L_done') }}
        </OnexButton>
      </v-col>
    </v-row>
  </v-main>
</template>

<script lang="ts">
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { useGlobalStore } from '@/stores/global/global.store';
import { mdiContentCopy } from '@mdi/js';
import { mapActions, mapState, mapStores } from 'pinia';
import { defineComponent, type ComponentOptions } from 'vue';
import { OnexButton } from '@primerica/onex-ui-lib';
import { RouteNames } from '@/router/routeNames';

const componentOptions: ComponentOptions = {
  name: 'PayStepThreeKubra',
  components: {
    OnexButton,
  },
  data: () => ({
    mdiContentCopy,
  }),
  computed: {
    ...mapStores(usePolicyStore),
    ...mapState(useCustomerStore, ['customerProfile']),
    ...mapState(usePolicyStore, [
      'policies',
      'currentPolicy',
      'routeNameToNavigateBack',
      'selectedPolicyIndex',
    ]),
    ...mapState(useGlobalStore, {
      locale: 'getLocale',
    }),
    contractId() {
      return this.currentPolicy?.contractId;
    },
    zipCode() {
      return this.currentPolicy?.owner?.address.zip;
    },
  },
  methods: {
    ...mapActions(usePolicyStore, ['getPolicyOverview']),
    async refreshAndClose() {
      this.$emit('close-external-kubra');
      await this.policyStore.getPolicyOverview(true); // refresh policy data
      this.policyStore.paymentInfoShowPaymentAmountDateBillingMethod = true;
      this.policyStore.paymentStep = -1;
      await this.$router.push({
        name: RouteNames.POLICY_DETAILS,
        params: { contractId: this.selectedPolicyIndex },
      });
    },
    async copyPolicyToClipboard() {
      await navigator.clipboard.writeText(this.contractId);
    },
  },
  mounted() {
    // * Dynatrace Tag (https://primerica.atlassian.net/wiki/spaces/PD/pages/19955873/Payments+-+Custom+Dynatrace+Tags)
    try {
      const i = this.$dynatrace.enterAction(
        'OneTimePayment_CreditCard_WelcomeBackMsg_PageDisplayed'
      );
      this.$dynatrace.leaveAction(i);
    } catch (_error) {
      /* empty */
    }
  },
};

export default defineComponent(componentOptions);
</script>

<style>
.bg-light-grey {
  background-color: #f5f5f5;
}
.clickable {
  cursor: pointer;
}
.blue_label {
  color: #02579e;
}

.maxwidthButton {
  max-width: 280px;
}
</style>
